<vc-loader *ngIf="!cards"></vc-loader>

<vc-ref *ngIf="cards" [resource]="urlApp" [blank]="true">
  <div class="promoteApp">
    <div class="promoteApp__logo">
      <vc-sprite-icons class="promoteApp__logo__icon" name="logo"></vc-sprite-icons>
    </div>
    <div class="promoteApp__content">
      <span class="promoteApp__content__name">Vestiaire Collective</span>
      <span class="promoteApp__content__action" i18n="@@FEED.PAGE.PROMOTE_APP">Download the app</span>
    </div>
  </div>
</vc-ref>

<div *ngIf="numberUpdates && feedType === 'default'" class="updateFeed vc-text-m">
  <p i18n="@@FEED.PAGE.NUMBER_UPDATES" class="updateFeed__info">
    You have <span>{{ numberUpdates }} updates </span>in your newsfeed
  </p>
</div>

<ul class="updateContent">
  <ng-container *ngFor="let card of cards; index as index; count as totalCards">
    <li class="updateContent__none vc-text-m" *ngIf="card.id === lastSeenCardId && index > 0 && feedType === 'default'">
      <vc-sprite-icons name="check" class="updateContent__none__icon"></vc-sprite-icons>
      <p i18n="@@FEED.PAGE.YOU_UP_DATE">You're up to date !</p>
      <vc-ref
        i18n="@@FEED.PAGE.SEE_MORE_SUGGESTIONS"
        class="updateContent__none__link vc-btn vc-btn--small vc-btn--full vc-btn--social"
        resource="feed/suggested"
      >
        Check best profiles
      </vc-ref>
    </li>
    <li *ngIf="labelMap[card.id]" class="updateContent__date vc-text-s">{{ labelMap[card.id] }}</li>
    <li>
      <vc-feed-card [likedItems]="likedItems" [card]="card"></vc-feed-card>
      <div *ngIf="index === totalCards - 2" #scroller><!-- Used for Infinite Scroll --></div>
    </li>
  </ng-container>
</ul>

<div *ngIf="(hasNewerCards$ | async) && feedType === 'default'" (click)="loadNewer()" class="updateTap vc-text-s">
  <vc-sprite-icons class="updateTap__icon" name="arrow-line-up"></vc-sprite-icons>
  <span i18n="@@FEED.PAGE.TAP_TO_UPDATE">Tap to update</span>
</div>
